import { Box, Typography, Modal, ModalDialog, ModalClose } from "@mui/joy";
import { Trash2 } from "lucide-react";

import { Button } from "../../../../../../shared";

import type { IProjectAsset } from "../../../../../../interfaces";

interface IDeleteAttachmentModalProps {
    attachment: IProjectAsset | null;
    isDeleting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export default function DeleteAttachmentModal({
    attachment,
    isDeleting,
    onCancel,
    onConfirm,
}: IDeleteAttachmentModalProps) {
    return (
        <Modal open={Boolean(attachment)} onClose={onCancel}>
            <ModalDialog variant="outlined" sx={{ borderRadius: "4px", maxWidth: 420 }}>
                <ModalClose />
                <Typography level="title-lg">Delete attachment?</Typography>
                <Typography level="body-sm" color="neutral">
                    {attachment?.Title} will be permanently removed from this project. This cannot be undone.
                </Typography>
                <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
                    <Button variant="plain" color="neutral" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button
                        variant="solid"
                        color="danger"
                        loading={isDeleting}
                        startDecorator={<Trash2 size={16} />}
                        onClick={onConfirm}
                    >
                        Delete
                    </Button>
                </Box>
            </ModalDialog>
        </Modal>
    );
}
